<template>
  <div class="container wc-container">
    <h3 style="margin-bottom:30px;">Attendees</h3>

    <Card style="margin-bottom:16px;">
      <Select v-model="selectedSession" style="width:400px">
        <Option v-for="item in sessions" :value="item.id" :key="item.id">{{ item.label }}</Option>
      </Select>
      <Select v-model="selectedStream" style="width:200px">
        <Option value="all" key="all">All Streams</Option>
        <Option v-for="item in streams" :value="item._id" :key="item._id">{{ item.name }}</Option>
      </Select>
      <Button type="primary" @click="getTableData">Load Report</Button>
      <Button type="primary" @click="exportTable()">
        <Icon type="ios-download-outline"></Icon>Export source data
      </Button>
    </Card>

    <Table
      :loading="loading"
      width="100%"
      height="500"
      border
      :columns="columns"
      :data="attData"
      size="small"
      ref="table"
    ></Table>
  </div>
</template>
<script>
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: true,
      columns: [],
      attData: [],
      selectedSession: null,
      sessions: {},
      selectedStream: null
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("stream", {
      streamsInStore: "find"
    }),
    ...mapGetters("registrations", {
      findRegistrationsInStore: "find"
    }),
    ...mapGetters("agg-connections", {
      aggregateConnectionsInStore: "find"
    }),
    ...mapGetters("page-settings", {
      pageSettings: "getCopy"
    }),
    regCount() {
      return this.findRegistrationsInStore({
        query: {
          $limit: 0,
          webcastId: this.webcast._id
        }
      }).total;
    },
    streams() {
      this.selectedStream = "all";
      return this.streamsInStore({ query: {} }).data;
    }
  },
  methods: {
    ...mapActions("attendees", {
      findAttendeesAction: "find"
    }),
    ...mapActions("agg-connections", {
      aggregateConnectionsAction: "find"
    }),
    ...mapActions("webcast-session", {
      findSessionAction: "find"
    }),
    ...mapActions("stream", {
      findStreamsAction: "find"
    }),
    ...mapActions("reg-form", {
      findRegFormFields: "find"
    }),
    exportTable() {
      this.$refs.table.exportCsv({
        filename: "attendees.csv"
      });
    },
    getTableData() {
      this.loading = true;
      this.attData = [];
      this.columns = [];
      let sampleRow = null;

      let query = {
        webcastId: this.webcast._id,
        streamId: this.selectedStream,
        sessionId: this.selectedSession,
        $sort: { createdAt: -1 }
      };

      if (this.pageSettings.registrationEnabled) {
        query["aggregateBy"] = "$reg._id";
      } else {
        query["aggregateBy"] = "$device._id";
      }

      //query['aggregateBy'] = '$device.ip'

      this.aggregateConnectionsAction({ query: query }).then(resp => {
        if (resp.length <= 0) {
          this.loading = false;
          return;
        }

        console.log(resp);

        if (resp.length <= 0) {
          this.loading = false;
          return;
        }
        sampleRow = resp[0].attData;

        console.log(sampleRow);

        if (sampleRow.reg) {
          if (sampleRow.reg.info) {
            _.forEach(sampleRow.reg.info, (value, key) => {
              this.$data.columns.push({
                title: _.capitalize(key),
                key: key,
                minWidth: 180,
                ellipsis: true
              });
            });
          }
        }

        this.$data.columns.push(
          {
            title: "Joined At",
            key: "started",
            align: "center",
            minWidth: 200,
            ellipsis: true
          },
          /*
          {
            title: "Longest Session (minutes)",
            key: "duration",
            align: "center",
            minWidth: 140,
            ellipsis: true
          },
          */
          {
            title: "Session Duration (minutes)",
            key: "total_duration",
            align: "center",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "Time on player (minutes)",
            key: "session_duration",
            align: "center",
            minWidth: 140,
            ellipsis: true
          }
        );

        /* device info */
        this.$data.columns.push(
          {
            title: "Browser",
            key: "browser",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "Type",
            key: "type",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "OS",
            key: "os",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "IP City",
            key: "ip_city",
            align: "left",
            minWidth: 140,
            ellipsis: true
          },
          {
            title: "IP Country",
            key: "ip_country",
            align: "left",
            minWidth: 140,
            ellipsis: true
          }
        );

        /* Prepare Row Data */

        let rows = [];
        _.forEach(resp, (row, key) => {
          let rowRecord = {};
          if (row != undefined) {
            if (_.has(row, "attData.reg.info")) {
              _.forEach(row.attData.reg.info, (value, key) => {
                rowRecord[key] = value;
              });
            }

            if (_.has(row, "attData.device")) {
              _.forEach(row.attData.device, (value, key) => {
                if (key == "city") {
                  key = "ip_city";
                }
                if (key == "country") {
                  key = "ip_country";
                }
                rowRecord[key] = value;
              });
            }

            rowRecord["duration"] = _.chain(row.duration / 60000)
              .toNumber()
              .floor(1);

            rowRecord["session_duration"] = _.chain(
              row.session_duration / 60000
            )
              .toNumber()
              .floor(1);
            rowRecord["total_duration"] = _.chain(row.total_duration / 60000)
              .toNumber()
              .floor(1);
            rowRecord["started"] = moment(row.started).format("HH:mm:ss");
            this.$data.attData.push(rowRecord);
          }
        });

        this.loading = false;
      });
    }
  },
  created() {
    this.$store.commit("session-connections/clearAll");
    this.$store.commit("webcast-session/clearAll");

    this.findSessionAction({
      query: {
        webcastId: this.webcast._id,
        $sort: {
          createdAt: -1 //Sort by Date Added DESC
        }
      }
    }).then(sessionList => {
      _.forEach(sessionList.data, (s, key) => {
        let start = moment(s.createdAt).format("LLL");
        let end = "";
        if (s.endAt) {
          end = moment(s.endAt).format("LLL");
        }

        this.$data.sessions[s._id] = {
          id: s._id,
          label: start + " - " + end
        };
      });

      this.selectedSession = sessionList.data[0]._id;

      this.findStreamsAction({
        query: {
          webcastId: this.webcast._id
        }
      }).then(streams => {
        this.getTableData();
      });
    });
  },
  mounted() {}
};
</script>
